<form [formGroup]="formGroup()" class="guarantor-form">
  <div class="guarantor-form__row guarantor-form__row--name">
    <app-title-name-form
      [formGroup]="formGroup().controls.titleNameForm"
      [showTitle]="true"
      [disabled]="disabled()"
    />
  </div>
  <div class="guarantor-form__row guarantor-form__row--connection">
    <app-validated-dropdown
      [label]="'general.formOfConnection'"
      inputFormControlName="formOfConnection"
      [inputFormControl]="formGroup().controls.formOfConnection"
      [haveEmptyOption]="true"
      [disabled]="disabled()"
    >
      @for (connection of personRoleStore.personRoleEntities(); track connection.id) {
        <option [value]="connection.id">
          {{ connection.localized | getLocalized }}
        </option>
      }
    </app-validated-dropdown>
  </div>
</form>
